import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const LogoutButton: React.FC = () => {
  const { logout } = useAuth0();
  return <button className="btn btn-outline-danger" onClick={() => logout({ logoutParams: { returnTo: window.location.origin, federated: true } })}>Log Out</button>;
};

export default LogoutButton;
